import { NavLink } from 'react-router-dom';
import { th, zIndexes } from 'style/theme';
import styled from 'styled-components';
import NILogo from 'products/nomad_insurance/assets/img/logos/nomad-insurance-black.svg';
import { sizes } from 'style';
import Menu from 'components/Menu';

export const ProductNavbar = styled.div`
  width: 100%;
  display: none;
  position: fixed;
  align-items: center;
  top: 0;
  left: 0;
  height: 60px;
  background: ${({ isHomepage }) =>
    isHomepage ? th('colors.transparentWhite.9') : th('colors.white')};
  padding-left: 20px;
  padding-right: 28px;
  z-index: ${zIndexes.dropdown};
  transition: 0.2s;

  @media ${sizes.desktop} {
    display: flex;
  }

  > button {
    margin-left: auto;
    padding: 9px 36px;
  }
`;

export const Logo = styled.div`
  cursor: pointer;
  background-image: url(${NILogo});
  transition: 0.2s;
  background-size: cover;
  width: 175px;
  height: 36px;

  &:hover {
    opacity: 0.8;
  }
`;

export const Link = styled(NavLink).attrs({ exact: true })`
  text-decoration: none;
  font-weight: 700;
  margin-left: 35px;
  position: relative;
  color: ${th('colors.black')};
  transition: 0.2s;

  &:hover {
    color: ${th('colors.transparentBlack.7')};
  }

  &.active {
    color: ${th('colors.red')};

    &::after {
      content: '';
      position: absolute;
      top: 115%;
      left: 50%;
      margin-left: -8px;
      border-width: 8px;
      border-style: solid;
      border-color: transparent transparent ${th('colors.red')} transparent;
    }
  }

  &:nth-child(3).active {
    color: ${th('colors.pink')};

    &::after {
      border-color: transparent transparent ${th('colors.pink')} transparent;
    }
  }

  &:nth-child(4).active {
    color: ${th('colors.orange')};

    &::after {
      border-color: transparent transparent ${th('colors.orange')} transparent;
    }
  }
`;

export const ProfileMenu = styled(Menu)`
  margin-left: auto;
`;
